import type { Socket } from 'socket.io-client'

export const listenAppAlert = (
  socket: Socket,
  callback: (alertMessage: string) => void,
) => {
  socket.on('alert', (alertMessage: string) => {
    callback(alertMessage)
  })
}

export const offListenAppAlert = (socket: Socket) => {
  socket.off('alert')
}
